module.exports = __webpack_public_path__ + "img/a8.c7c4aa3b.jpg";